import React from "react";
import { Route, Routes } from "react-router-dom";
import VerifyPhoneNumber from "./verify/VerifyPhoneNumber";
import Liveness from "./verify/Liveness";

const Verify = () => {
  return (
    <Routes>
      <Route path="/phone-number" element={<VerifyPhoneNumber />} />
      <Route path="/liveness" element={<Liveness />} />
    </Routes>
  );
};

export default Verify;
